module.exports = __webpack_public_path__ + "static/media/Storage.d3c16b91.svg";